<div class="container">
  <div class="row mt-3">
    <div class="col">
      <div class="card">
        <div class="card-body">
          <h3 class="m-0">Request new Event</h3>
          <hr />
          <div class="row">
            <div class="col-6">
              <div class="form-group">
                <label>Event name*</label>
                <input type="text" class="form-control form-control-sm" [(ngModel)]="event.eventName"
                  placeholder="Event name" />
              </div>
            </div>
            <div class="col">
              <div class="form-group">
                <label>Organization*</label>
                <app-client-select-modal (clientSelected)="onClientSelectedEvent($event)" [showLabel]="false">
                </app-client-select-modal>
              </div>
            </div>
            <div class="col">
              <div class="form-group">
                <label>Event language*</label>
                <select class="form-control form-control-sm" [(ngModel)]="event.language">
                  <option *ngFor="let language of eventLanguageArray" [value]="language.value">
                    {{language.label}}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-3">
              <div class="form-group">
                <label>Village*</label>
                <ng-select [items]="villageOptions" class="custom" [(ngModel)]="choosenVillage"></ng-select>
              </div>
            </div>
            <div class="col-3">
              <div class="form-group">
                <label>Village fraction</label>
                <input type="text" class="form-control form-control-sm" [(ngModel)]="event.zone" />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <app-form-group-datepicker [label]="'request-event-modal.start-date' | translate" [(model)]="startDate"
                (modelChange)="onDateChange('startDate')">
              </app-form-group-datepicker>
            </div>
            <div class="col">
              <app-form-group-datepicker [label]="'request-event-modal.end-date' | translate" [(model)]="endDate"
                (modelChange)="onDateChange('endDate')">
              </app-form-group-datepicker>
            </div>
            <div class="col">
              <app-form-group-datepicker [label]="'request-event-modal.pickup-date' | translate" [(model)]="pickUpDate">
              </app-form-group-datepicker>
            </div>
            <div class="col">
              <app-form-group-datepicker [label]="'request-event-modal.return-date' | translate" [(model)]="returnDate">
              </app-form-group-datepicker>
            </div>
          </div>
          <hr />
          <div class="row">
            <div class="col">
              <h4 class="mt-0">{{'request-event-modal.software' | translate}}</h4>
              <div class="row">
                <div class="col">
                  <app-form-group-number-input [(model)]="softwareProductsAmount.waiter"
                    [label]="'request-event-modal.waiters' | translate"
                    (modelChange)="onSoftwareTypeQuantityChange('waiter', 1)">
                  </app-form-group-number-input>
                </div>
                <div class="col">
                  <app-form-group-number-input [(model)]="softwareProductsAmount.cashRegister"
                    [label]="'request-event-modal.cash-register' | translate"
                    (modelChange)="onSoftwareTypeQuantityChange('cashRegister', 2)">
                  </app-form-group-number-input>
                </div>
                <div class="col">
                  <app-form-group-number-input [(model)]="softwareProductsAmount.mainDevice"
                    [label]="'request-event-modal.main-device' | translate"
                    (modelChange)="onSoftwareTypeQuantityChange('mainDevice', 3)">
                  </app-form-group-number-input>
                </div>
                <div class="col">
                  <app-form-group-number-input [(model)]="softwareProductsAmount.printer"
                    [label]="'request-event-modal.printers' | translate"
                    (modelChange)="onSoftwareTypeQuantityChange('printer', 4)">
                  </app-form-group-number-input>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <h4 class="mt-0">{{'request-event-modal.hardware' | translate}}</h4>
              <div class="row">
                <div class="col">
                  <app-form-group-number-input [(model)]="hardwareProductsAmount.phones"
                    [label]="'request-event-modal.phones' | translate"
                    (modelChange)="onHardwareTypeQuantityChange('phones', 1)">
                  </app-form-group-number-input>
                </div>
                <div class="col">
                  <app-form-group-number-input [(model)]="hardwareProductsAmount.printers"
                    [label]="'request-event-modal.printers' | translate"
                    (modelChange)="onHardwareTypeQuantityChange('printers', 1)">
                  </app-form-group-number-input>
                </div>
                <div class="col">
                  <app-form-group-number-input [(model)]="hardwareProductsAmount.routers"
                    [label]="'request-event-modal.routers' | translate"
                    (modelChange)="onHardwareTypeQuantityChange('routers', 1)">
                  </app-form-group-number-input>
                </div>
                <div class="col">
                  <app-form-group-number-input [label]="'request-event-modal.ups' | translate"
                    [(model)]="hardwareProductsAmount.ups" (modelChange)="onHardwareTypeQuantityChange('ups', 1)">
                  </app-form-group-number-input>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <h4 class="mt-0">Cable</h4>
            </div>
            <div class="col">
              <app-form-group-number-input [label]="'request-event-modal.cable-1m' | translate"
                [(model)]="cableProductsAmount.one" (modelChange)="onCableTypeQuantityChange('one', 1)">
              </app-form-group-number-input>
            </div>
            <div class="col">
              <app-form-group-number-input [label]="'request-event-modal.cable-5m' | translate"
                [(model)]="cableProductsAmount.five" (modelChange)="onCableTypeQuantityChange('five', 2)">
              </app-form-group-number-input>
            </div>
            <div class="col">
              <app-form-group-number-input [label]="'request-event-modal.cable-10m' | translate"
                [(model)]="cableProductsAmount.ten" (modelChange)="onCableTypeQuantityChange('ten', 3)">
              </app-form-group-number-input>
            </div>
            <div class="col">
              <app-form-group-number-input [label]="'request-event-modal.cable-20m' | translate"
                [(model)]="cableProductsAmount.twenty" (modelChange)="onCableTypeQuantityChange('twenty', 5)">
              </app-form-group-number-input>
            </div>
            <div class="col">
              <app-form-group-number-input [label]="'request-event-modal.cable-50m' | translate"
                [(model)]="cableProductsAmount.fifty" (modelChange)="onCableTypeQuantityChange('fifty', 7)">
              </app-form-group-number-input>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <div class="row">
            <div class="col">
              <a class="btn btn-default btn-sm btn-wd" href="/events/all">
                <i class="fa fa-times"></i> <br /> Cancel
              </a>
            </div>
            <div class="col text-center">
              <h3 class="align-middle mt-1">{{eventPrice | currency:'€ '}}</h3>
            </div>
            <div class="col text-right">
              <button class="btn btn-primary btn-sm btn-wd" type="button" (click)="submitEventRequest()">
                <i class="fa fa-save"></i> <br />
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
